import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import api from '../../API/api';
import Loader from '../panel/loader';


import CustomizedMenus from '../panel/dropdown';
import DocumentViewMenu from '../panel/documentViewMenu';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));




export default function BrochureData() {

    const [data, setdata] = useState([]);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        getBrochure();
    }, []);

    const getBrochure = () => {
        setLoad(true)
        api.getBrochure().then((res) => {
            // console.log(res);
            setdata(res.data.data)
            setLoad(false)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }



    return (

        <Paper>

            {load && <Loader />}


            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell> Name</StyledTableCell>
                            <StyledTableCell align="">Email</StyledTableCell>
                            <StyledTableCell align="">Phone</StyledTableCell>
                            <StyledTableCell align="">Course Selected</StyledTableCell>
                            <StyledTableCell align="">Downloaded Date</StyledTableCell>
                            {/* <StyledTableCell align="">Action</StyledTableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <StyledTableRow key={row.id}>
                                <StyledTableCell component="th" scope="row">
                                    {row.name}
                                </StyledTableCell>
                                <StyledTableCell align="">{row.email}</StyledTableCell>
                                <StyledTableCell align="">{row.phoneno}</StyledTableCell>
                                <StyledTableCell align="">{row.course}</StyledTableCell>
                                <StyledTableCell align="">
                                    {new Date(row.created_at).getDate()
                                        + ", " +
                                        new Date(row.created_at).toLocaleString("default", { month: "long", })
                                        + "-" +
                                        new Date(row.created_at).getFullYear()}
                                </StyledTableCell>
                                {/* <StyledTableCell align="">
                                    <CustomizedMenus id={row} getAdmissionData={getAdmissionData} />
                                </StyledTableCell> */}
                                
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>
    );
}